import { useMemo } from 'react';
import { getInstance as getBootstrap } from 'utils/bootstrap';

export function useBootstrap(keys) {
    return useMemo(() => getBootstrap().getMultiple(...keys), [keys]);
}
